import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrayHelper from 'foundation/array-helper';
import Scrollable from 'general/js/scrollable';
import CustomEventLeaderboardScoreCell from './custom-event-leaderboard-score-player-cell';

class CustomEventLeaderboardHoleByHoleWidget extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
        this.innerRef = React.createRef();

        this.scrollable = null;
        this.isPointsBased = props.isPointsBased;
    }

    componentDidMount() {
        if (this.props.isScrollable) {
            this.scrollable = new Scrollable(this.rootRef.current, this.innerRef.current);
        }
    }

    componentWillUnmount() {
        if (this.scrollable) {
            this.scrollable.destroy();
        }
    }

    renderCell(key, value = '', type = {}) {
        const typeCss = classNames({
            'is-wide': type.isWide
        });

        return (
            <div key={key} className={`live-player-scores__cell ${typeCss}`}>
                {value}
            </div>
        );
    }

    getHoleScore(holePar, value) {
        if (value === 0) return value;

        if (value > holePar) return `+${value - holePar}`;

        if (value === holePar) return 'E';

        if (value < holePar) return `-${holePar - value}`;

        return value;
    }

    getHolePlayingStatus(status, lineType = 'normal') {
        if (status === null || status === undefined) {
            return null;
        }

        return lineType === 'normal' ? status.status : status.bonusPointsStatus;
    }

    renderPlayerScore(key, holePar, value, status, lineType = 'normal') {
        const score = this.isPointsBased ? value : this.getHoleScore(holePar, value);

        const statusValue = this.getHolePlayingStatus(status, lineType);

        const holeParForCell = lineType === 'normal' ? holePar : null;

        return (
            <CustomEventLeaderboardScoreCell
                key={key}
                childCss={'live-player-scores__player-cell'}
                holePar={holeParForCell}
                playerPar={score}
                status={statusValue}
                isPointsBased={this.isPointsBased}
            />
        );
    }

    renderHeadLine() {
        const { holesToBePlayed } = this.props;

        return (
            <div className="live-player-scores__head">
                {holesToBePlayed.map((hole, i) => this.renderCell(`h-${i}`, hole.holeNumber))}
            </div>
        );
    }

    renderHoleParLine() {
        const { holesToBePlayed } = this.props;

        return (
            <div className="live-player-scores__row">
                {holesToBePlayed.map((hole, i) => this.renderCell(`h-${i}`, hole.holePar))}
            </div>
        );
    }

    getScoreValue(holeInfo, isPointsBased, lineType = 'normal') {
        if (holeInfo === null || holeInfo === undefined) {
            return null;
        }

        if (lineType === 'normal') {
            return !isPointsBased || holeInfo.playerStrokes > 0 ? holeInfo.playerPar : null;
        }
        return holeInfo.playerBonus >= 0 ? holeInfo.playerBonus : null;
    }

    renderPlayerScoreLine(isPointsBased, lineType = 'normal') {
        const { holesToBePlayed, scoringPlayerRound, playerSitecoreData } = this.props;

        if (lineType === 'bonus') {
            const playerHasBonusPoints = scoringPlayerRound.info.some(
                (holeInfo) => holeInfo.playerBonus >= 0
            );
            if (!playerHasBonusPoints) {
                return null;
            }
        }

        if (!scoringPlayerRound || ArrayHelper.isEmpty(scoringPlayerRound.info)) {
            return (
                <div className="live-player-scores__player">
                    {holesToBePlayed.map((_, i) => {
                        return (
                            <div
                                key={`empty-${i}`}
                                className="live-player-scores__player-cell score-cell score-cell--default score-cell--has-border"
                            >
                                -
                            </div>
                        );
                    })}
                </div>
            );
        }

        const playerHasInfo =
            playerSitecoreData !== null &&
            playerSitecoreData !== undefined &&
            playerSitecoreData.playerStatuses !== undefined &&
            playerSitecoreData.playerStatuses !== null &&
            !ArrayHelper.isEmpty(playerSitecoreData.playerStatuses);

        return (
            <div className="live-player-scores__player">
                {holesToBePlayed.map((hole) => {
                    const holeInfo =
                        scoringPlayerRound.info.find((r) => r.holeId === hole.holeNumber) || null;
                    const playerHoleStatus = playerHasInfo ?
                        playerSitecoreData.playerStatuses.find((holeStatus) => holeStatus.hole.number === hole.holeNumber) :
                        null;

                    return this.renderPlayerScore(
                        `p-${hole.holeNumber - 1}`,
                        hole.holePar,
                        this.getScoreValue(holeInfo, isPointsBased, lineType),
                        playerHoleStatus,
                        lineType
                    );
                })}
            </div>
        );
    }

    render() {
        const { scoringPlayerRound, isScrollable, isPointsBased } = this.props;
        const stateCss = classNames({
            'is-empty': !scoringPlayerRound || ArrayHelper.isEmpty(scoringPlayerRound.info),
            'is-scrollable': isScrollable
        });

        return (
            <div className={`live-player-scores ${stateCss}`} ref={this.rootRef}>
                <div className="live-player-scores__inner" ref={this.innerRef}>
                    <div className="live-player-scores__list">
                        {this.renderHeadLine()}
                        {!isPointsBased && this.renderHoleParLine()}
                        {this.renderPlayerScoreLine(isPointsBased, 'normal')}
                        {isPointsBased &&
                            this.renderPlayerScoreLine(isPointsBased, 'bonus')}
                    </div>
                </div>
            </div>
        );
    }
}

CustomEventLeaderboardHoleByHoleWidget.propTypes = {
    scoringPlayerRound: PropTypes.object,
    scoringCourse: PropTypes.object,
    isScrollable: PropTypes.bool
};

export default CustomEventLeaderboardHoleByHoleWidget;
